import React from "react";
import styled from "styled-components";
import { Modal, colors2, UI_BODY_SEMIBOLD, ButtonGhostV2 } from "oolib";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/**
 * Shared shell for the compact import modals (source selection + add data):
 * oolib's Modal with a custom header. Only used for modal launches, where the
 * DirectDataImportModal wrapper renders the backdrop — so we pass hideBackdrop
 * to suppress oolib's own (one modal, one overlay). Full-page routes render the
 * compact content inline instead, without this shell. The leading element is the
 * DownloadSimple icon, or — when `onBack` is provided — a back button that
 * returns to the previous step.
 */
export const ImportModalShell = ({
  onClose,
  onBack,
  title = "Import Data",
  desktopWidth = "64rem",
  children,
}) => (
  // overflowVisible: the body wrapper defaults to overflow: auto (oolib's
  // takeFullScreenOnScroll), which holds the taller height when swapping the
  // (taller) source-selection and (shorter) add-data views — leaving dead space
  // below the content. overflowVisible unsets it so the wrapper hugs the view.
  <Modal
    title={title}
    onClose={onClose}
    disableHeader
    fitToContentHeight
    overflowVisible
    hideBackdrop
    showActionPanel={false}
    desktopWidth={desktopWidth}
  >
    <Body>
      <Header>
        <HeaderLeft>
          {onBack ? (
            <ButtonGhostV2
              icon="ArrowLeft"
              onClick={onBack}
              style={{ padding: 4, marginLeft: -4 }}
            />
          ) : (
            <DisplayIcon icon="DownloadSimple" size={20} color={colors2.grey80} />
          )}
          <UI_BODY_SEMIBOLD>
            {onBack ? "Back to source selection" : title}
          </UI_BODY_SEMIBOLD>
        </HeaderLeft>
        <ButtonGhostV2 icon="X" onClick={onClose} style={{ padding: 4, marginRight: -4 }} />
      </Header>
      {children}
    </Body>
  </Modal>
);

export default ImportModalShell;
